import { ApolloLink } from "@apollo/client";
const customHeadersLink = new ApolloLink((operation, forward)=>{
    if ("u" > typeof window && window.crehApolloHeaders) operation.setContext(({ headers = {} })=>({
            headers: {
                ...headers,
                ...window.crehApolloHeaders || {}
            }
        }));
    return forward(operation);
});
export { customHeadersLink };
